import { CommApiInstance } from "Utils/CommApiInstance";

const MembNtfyMsgSttuChngApi = async (
    msgSno:string,
    ntfyChngSttuType:string
) => {
    return await CommApiInstance.post(`memb/ntfy_msg/sttu/chng/${msgSno}`,{
        apiBody:{
            ntfyChngSttuType:ntfyChngSttuType
        },
    })
    .then((Resp) => Resp.data);
}
export default MembNtfyMsgSttuChngApi;